import Swiper, { Autoplay, Navigation } from 'swiper';

let testimonialsSwiperWr = document.querySelectorAll('.testimonials-sec-swiper-wr');
let testimonialsList = document.querySelectorAll('.testimonials-sec__left li');

testimonialsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let swiperInstance = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      spaceBetween: 48,
      slidesPerView: 'auto',
      loop: false,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        500: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          spaceBetween: 24,
          slidesPerView: 2,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 640,
      },
    });

  }
});
